import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from "i18next";
import "./DelayCausesList.scss";
export const DelayCausesList = ({ delayCodes }) => {
    const top3DelayCodes = (delayCodes === null || delayCodes === void 0 ? void 0 : delayCodes.filter((x) => x.greaterthan15min > 0).slice().sort((a, b) => b.greaterthan15min - a.greaterthan15min).slice(0, 3)) || [];
    const delayNumbersData = top3DelayCodes.map((delayCode) => ({
        name: delayCode.delaycode,
        value: delayCode.greaterthan15min,
    }));
    return (_jsxs("section", { className: "delay-causes-list", children: [_jsx("h4", { className: "delay-causes-list-header", children: t("onTimePerformance.delay.widgets.summary.title") }), _jsx("div", { className: "delay-causes-list-container", children: delayNumbersData
                    .map((delay, index) => (_jsx("div", { children: _jsx("span", { children: `${index + 1}. ${delay.name} (${delay.value})` }) }, index))) })] }));
};
